import React, { Component } from 'react';
import { Form, Field } from 'redux-form';
import PropTypes from 'prop-types';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import Typography from '@material-ui/core/Typography';
import {
  RenderTextField as TextField,
  RenderDropDownField as DropDown, RenderSwitchField as Switch, RenderRadioGroupField as RadioGroup,
  UploadField
} from '../../formInputs';

import Message from '../Message';
import FilesList from '../FileLists';
import SnackbarContent from '@material-ui/core/SnackbarContent';
import ErrorIcon from '@material-ui/icons/Error';
import { required } from '../../utils/validations';
import { POST_FILES_FOLDER } from '../../constants';

const styles = theme => ({
  layout: {
    width: 'auto',
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing.unit * 8,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'left',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  form: {
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  success: {
    // backgroundColor: green500,
  },
  message: {
    display: 'flex',
    alignItems: 'center',
  },
  error: {
    marginTop: 10,
    color: '#ffffff',
    backgroundColor: theme.palette.error.dark,
  },
  snackbar: {
    margin: theme.spacing.unit,
  },
  icon: {
    fontSize: 20,
  },
  iconVariant: {
    opacity: 0.9,
    marginRight: theme.spacing.unit,
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  title: {
    marginTop: 10,
  },
  radioBtn: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  }
});

class PostForm extends Component {
  static propTypes = {
    classes: PropTypes.object,
    handleSubmit: PropTypes.func,
    user: PropTypes.object,
    removeMessage: PropTypes.func,
    error: PropTypes.string,
    addPost: PropTypes.func,
    formName: PropTypes.string
  };

  state = {
    isActive: this.props.isActive,
    postType: String(this.props.type) || '1'
  }


  handleChangeIsActive = () => {
    const { isActive } = this.state;
    this.setState({ isActive: !isActive });
  }

  handleChange = (element) => {
    this.setState({ postType: element.target.value });
  }

  render() {
    const {
      classes,
      handleSubmit,
      addPost,
      message,
      error,
      userList,
      postImages,
      deleteImage,
      formName
    } = this.props;

    const { isActive, postType } = this.state;

    const users = userList.map(u => {
      return {
        label: `${u.userDetail && u.userDetail.firstName} ${u.userDetail && u.userDetail.lastName}`,
        value: u.id
      }
    });

    return (
      <React.Fragment>

        {
          (error !== undefined) &&
          <SnackbarContent
            className={classes.error}
            message={
              <span className={classes.message}>
                <ErrorIcon className={`${classes.icon} ${classes.iconVariant}`} />
                {error.toString()}
              </span>
            }
          />
        }

        <Message message={message} isOpen={message ? true : false} />

        <Typography variant="h5" className={classes.title}>{formName} Post</Typography>

        <Form className={classes.form} onSubmit={handleSubmit(addPost)}>

          <FormControl margin="normal" className={classes.textField} required>
            <FormLabel component="legend">Type</FormLabel>
            <Field
              name="type"
              component={DropDown}
              helperText="Select type"
              options={[
                {
                  label: 'Roomer Post',
                  value: '1'
                },
                {
                  label: 'Social Post',
                  value: '0'
                }]}
              onChange={(e) => this.handleChange(e)}
            />
          </FormControl>
          <FormControl margin="normal" className={classes.textField} required>
            <FormLabel component="legend">User</FormLabel>
            <Field
              name="userId"
              component={DropDown}
              helperText="Select User"
              options={users || []}
            />
          </FormControl>

          <FormControl margin="normal" className={classes.textField}>
            <Field name="link" component={TextField} label="Post Link" />
          </FormControl>

          {
            postType === '1' &&
            <FormControl margin="normal" className={classes.textField} required>
              <Field name="city" component={TextField} label="City Name" />
            </FormControl>
          }

          {
            postType === '1' && <FormControl margin="normal" className={classes.textField} required>
              <Field name="monthly_rent_amount" component={TextField} label="Monthly Rent Amount" />
            </FormControl>
          }


          {
            postType === '1' && <FormControl margin="normal" className={classes.textField} required>
              <FormLabel component="legend">With In</FormLabel>
              <Field
                name="distance"
                component={DropDown}
                helperText="Select within"
                options={[{
                  label: '1 mile',
                  value: '1'
                },
                {
                  label: '5 miles',
                  value: '5'
                },
                {
                  label: '10 miles',
                  value: '10'
                },
                {
                  label: '50 miles',
                  value: '50'
                },
                {
                  label: '100 miles',
                  value: '100'
                },
                {
                  label: '200 miles',
                  value: '200'
                }]}
              />
            </FormControl>

          }

          {
            postType === '1' && <FormControl margin="normal" className={classes.textField} required>
              <FormLabel component="legend">Type of Property</FormLabel>
              <Field
                name="property_type"
                component={DropDown}
                helperText="Select property"
                options={[{
                  label: 'Kothi',
                  value: 'Kothi'
                },
                {
                  label: 'Apartment',
                  value: 'Apartment'
                },
                {
                  label: 'Flat',
                  value: 'Flat'
                }]}
              />
            </FormControl>

          }

          {
            postType === '1' && <FormControl margin="normal" className={classes.textField} required>
              <Field name="lease_terms" component={TextField} label="Lease Terms" />
            </FormControl>
          }


          {
            postType === '1' && <FormControl margin="normal" className={classes.textField}>
              <Field name="college" component={TextField} label="College Name" />
            </FormControl>
          }

          {
            postType === '1' && <FormControl margin="normal" className={classes.textField}>
              <FormLabel component="legend">Course of Study</FormLabel>
              <Field
                name="course"
                component={DropDown}
                helperText="Select course of study"
                options={[{
                  label: 'B.Tech',
                  value: 'B.Tech'
                },
                {
                  label: 'M.Tech',
                  value: 'M.Tech'
                },
                {
                  label: 'BCA',
                  value: 'BCA'
                },
                {
                  label: 'MCA',
                  value: 'MCA'
                },
                {
                  label: 'BSC',
                  value: 'BSC'
                }]}
              />
            </FormControl>

          }


          {
            postType === '1' && <FormControl margin="normal" className={classes.textField} required>
              <FormLabel component="legend">Age Range</FormLabel>
              <Field
                name="age_range"
                component={DropDown}
                helperText="Select age range"
                options={[{
                  label: '10-15',
                  value: '10-15'
                },
                {
                  label: '16-25',
                  value: '16-25'
                },
                {
                  label: '26-40',
                  value: '26-40'
                },
                {
                  label: '41-60',
                  value: '41-60'
                },
                {
                  label: 'Above 60',
                  value: '60-100'
                }]}
              />
            </FormControl>

          }

          {
            postType === '1' && <FormControl margin="normal" className={classes.textField} required>
              <FormLabel component="legend">Move in Date</FormLabel>
              <Field
                name="move_in_date"
                component={TextField}
                type="Date"
              />
            </FormControl>
          }


          {
            <FormControl margin="normal" fullWidth required >
              <Field
                name="content"
                component={TextField}
                label="Content"
                multiline
                rowsMax="10"
                required
              />
            </FormControl>
          }

          

          <FormControl margin="normal" required fullWidth>
            <FormLabel component="legend">Upload Post Pictures </FormLabel>
            <Field
              name="postImages"
              component={UploadField}
              label="Upload Profile Pic"
              folderName={POST_FILES_FOLDER}
            />
          </FormControl>

          {
            postImages &&
            <FilesList
              list={postImages}
              deleteItem={deleteImage}
              folderName={POST_FILES_FOLDER}
            />
          }

          {
            postType === '1' && <FormControl margin="normal" className={classes.radioBtn}>
              <FormLabel component="legend">Pet Friendly</FormLabel>
              <Field
                name="pet_friendly"
                component={Switch}
                checked={isActive}
                onChange={this.handleChangeIsActive}
              />
            </FormControl>
          }

          {
            postType === '1' && <FormControl margin="normal" className={classes.radioBtn}>
              <FormLabel component="legend">Alcohol Okay</FormLabel>
              <Field
                name="alcoholic"
                component={Switch}
                checked={isActive}
                onChange={this.handleChangeIsActive}
              />
            </FormControl>
          }

          {
            postType === '1' && <FormControl margin="normal" className={classes.radioBtn}>
              <FormLabel component="legend">Smoker</FormLabel>
              <Field
                name="smoker"
                component={Switch}
                checked={isActive}
                onChange={this.handleChangeIsActive}
              />
            </FormControl>
          }

          {
            postType === '1' && <FormControl margin="normal" className={classes.radioBtn}>
              <FormLabel component="legend">420 Friendly</FormLabel>
              <Field
                name="friendly"
                component={Switch}
                checked={isActive}
                onChange={this.handleChangeIsActive}
              />
            </FormControl>
          }

          {
            postType === '1' && <FormControl margin="normal" fullWidth className={classes.radioBtn}>
              <FormLabel component="legend">Gender</FormLabel>
              <Field
                name="gender"
                component={RadioGroup}
                options={[
                  {
                    text: 'Male',
                    value: '1'
                  },
                  {
                    text: 'Female',
                    value: '2'
                  },
                  {
                    text: 'Others',
                    value: '3'
                  }
                ]}
              />
            </FormControl>

          }


          {
            postType === '1' && <FormControl margin="normal" fullWidth className={classes.radioBtn}>
              <FormLabel component="legend">No. of Bedrooms</FormLabel>
              <Field
                name="bedrooms"
                component={RadioGroup}
                options={[
                  {
                    text: '1',
                    value: '1'
                  },
                  {
                    text: '2',
                    value: '2'
                  },
                  {
                    text: '3',
                    value: '3'
                  },
                  {
                    text: '4',
                    value: '4'
                  }
                ]}
              />
            </FormControl>
          }

          {
            postType === '1' && <FormControl margin="normal" fullWidth className={classes.radioBtn}>
              <FormLabel component="legend">No. of Roommates</FormLabel>
              <Field
                name="roommates"
                component={RadioGroup}
                options={[
                  {
                    text: '1',
                    value: '1'
                  },
                  {
                    text: '2',
                    value: '2'
                  },
                  {
                    text: '3',
                    value: '3'
                  },
                  {
                    text: '4',
                    value: '4'
                  }
                ]}
              />
            </FormControl>
          }

          <FormControl margin="normal" fullWidth className={classes.radioBtn}>
            <FormLabel component="legend">Is Deleted</FormLabel>
            <Field
              name="isDeleted"
              component={Switch}
              checked={isActive}
              onChange={this.handleChangeIsActive}
            />
          </FormControl>

          <Button
            type="submit"
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Save Post
          </Button>

        </Form>

      </React.Fragment>
    );
  }
}

export default withStyles(styles)(PostForm);